import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getCompanyById,
  selectCompany,
} from "../../redux/company/companySlice";

function CompanyDetail() {
  const { companyId } = useParams();
  const company = useSelector(selectCompany);
  const dispatch = useDispatch();
  console.log("company", company);
  useEffect(() => {
    dispatch(getCompanyById(companyId));
  }, []);
  return (
    <div className="p-10">
      <h1>{company?.form?.name}</h1>
      {company?.form?.fields.map((val, index) => (
        <div key={index} className="border-b border-b-black">
          <div className="flex gap-10">
            <label>Type</label>
            <p>{val.type}</p>
          </div>
          <div className="flex gap-10">
            <label>Label</label>
            <p>{val.label}</p>
          </div>
          <div className="flex gap-10">
            <label>Name</label>
            <p>{val.name}</p>
          </div>
          <div className="flex gap-10">
            <label>Placeholder</label>
            <p>{val.placeholder}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CompanyDetail;
